module.exports = {
  EMAIL_REGEX:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  APP_NAME_GENERAL: "hireHQ",
  APP_NAME_DIRECT_HEALTH: "Direct Health",
  APP_NAME_NEURODIVERSIFY: "Neurodiversify",
};
